import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Link,
  Spacer,
  Stack,
  Text,
  useMediaQuery,
  useRadioGroup,
  VStack
} from '@chakra-ui/react';
import { useRadio } from '@chakra-ui/react';
import {
  Carousel,
  LeftButton,
  Provider,
  RightButton
} from 'chakra-ui-carousel';
import { useEffect, useState } from 'react';

export const FormRadioCard = (props: any) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const [isMobile] = useMediaQuery('(max-width: 920px)');
  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        border="3px solid transparent"
        color="#001E64"
        fontWeight="bold"
        borderRadius="full"
        w={isMobile ? '39vw' : '280px'}
        py="10px"
        textAlign="center"
        _checked={{
          bg: '#FA6B25',
          color: 'white'
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export const BrokerHome = (): JSX.Element => {
  const [panelSelected, setPanelSelected] = useState('Gestão de Carteira');
  const options = ['Gestão de Carteira', 'Oportunidades SulAmérica'];
  const [isMobile] = useMediaQuery('(max-width: 920px)');

  const informations = {
    corretor: [
      {
        title: 'Viagem',
        cards: [
          {
            subtitle: 'Carteira Viagem',
            href: 'corretor/viagem/carteira-viagem',
            text: 'Acompanhe os status e dados imporantes das apólices de Seguro Viagem.',
            tag: ''
          }
        ]
      },
      {
        title: 'Vida Individual',
        cards: [
          {
            subtitle: 'Painel de Vendas Contrata Fácil',
            href: 'corretor/vida-individual/painel-vendas-contrata-facil',
            text: 'Volume de vendas efetuadas e não efetuadas, distribuição por vendedor etc...',
            tag: ''
          },
          {
            subtitle: 'Carteira Vida',
            href: 'corretor/vida-individual/carteira-vida',
            text: 'Todos os clientes em um só lugar, acompanhe os status e dados importantes das apólices.',
            tag: ''
          }
        ]
      },
      {
        title: 'Previdência Individual',
        cards: [
          {
            subtitle: 'Carteira Previdência',
            href: '/corretor/previdencia-individual/carteira-previdencia',
            text: 'A sua carteira à disposição, acompanhe a evolução do saldo, distribuição dos fundos e muito mais.',
            tag: ''
          },
          {
            subtitle: 'Resgates (Consulta)',
            href: '/corretor/previdencia-individual/consulta-resgates',
            text: 'Toda movimentação organizada por período, participante, valores e etc...',
            tag: ''
          },
          {
            subtitle: 'SOS Prev',
            href: '/corretor/previdencia-individual/sos-prev',
            text: '',
            tag: ''
          },
          {
            subtitle: 'Carteira Recomendada',
            href: '/corretor/previdencia-individual/carteira-recomendada',
            text: 'Indique o melhor fundo de investimento para seus clientes, acesse aqui nossas recomendações.',
            tag: ''
          },
          {
            subtitle: 'Realizar Movimentação Entre Fundos',
            href: '/corretor/previdencia-individual/movimentacao-fundos/base-clientes',
            text: 'Agora é possível realizar a transferência total ou parcial da reserva do fundo atual de seus clientes.',
            tag: 'Novo'
          }
        ]
      }
    ],
    oportunidades: [
      {
        title: 'Gestão de Leads',
        text: 'Tela de distribuição de leads, demonstrando o avanço no contato com cliente.',
        href: '/corretor/leads',
        btnText: 'Acessar painel',
        tag: ''
      },
      {
        title: 'Meu Contrata Fácil',
        text: 'Criei aqui  um site totalmente personalizado com imagens, textos e produtos customizáveis.',
        href: '/corretor/white-label/painel',
        btnText: 'Criar meu novo site',
        tag: ''
      }
    ]
  };
  const { getRadioProps } = useRadioGroup({
    name: 'rating',
    defaultValue: 'Gestão de Carteira',
    onChange: setPanelSelected
  });

  useEffect(() => {
    const isScrollDisabled = document.body.style.overflow === 'hidden';

    if (isScrollDisabled) {
      document.body.style.overflow = 'auto';
    }
  }, []);

  return (
    <Stack spacing={23}>
      <Flex
        fontWeight="bold"
        bg="#FFFFFF"
        w="100%"
        h={'223px'}
        p="36px 0"
        textAlign="center"
        direction="column"
      >
        <Heading fontSize="2rem" color="#001E64">
          Sua Nova Plataforma de Negócios
        </Heading>
        <Spacer />
        <HStack
          spacing="1rem"
          pointerEvents={'all'}
          opacity={'1'}
          padding="11px 17px"
          bg="#F4F4F4"
          borderRadius="full"
          justifyContent="space-between"
          width={isMobile ? '90vw' : '618px'}
          margin={'0 auto'}
        >
          {options.map((value) => {
            const radio = getRadioProps({ value });
            return (
              <FormRadioCard key={value} {...radio}>
                {value}
              </FormRadioCard>
            );
          })}
        </HStack>
      </Flex>

      <Flex
        p={isMobile ? '1rem' : '1.25rem 2.50rem'}
        direction="column"
        gap="2rem"
      >
        {process.env.REACT_APP_MAINTENANCE_ALERT_ACTIVE === 'true' && (
          <Alert status="warning" borderRadius="8px">
            <AlertIcon />
            <AlertDescription fontSize="0.9rem">
              {process.env.REACT_APP_MAINTENANCE_ALERT_MESSAGE}
            </AlertDescription>
          </Alert>
        )}

        {panelSelected === 'Gestão de Carteira' ? (
          <>
            {informations.corretor.map((information) => {
              return (
                <VStack
                  key={information.title}
                  textAlign="left"
                  margin="0 auto !important"
                  bg="#fff"
                  w="100%"
                  border="1px solid #D0D0D0"
                  borderRadius="11px"
                >
                  <Heading
                    borderBottom="1px solid #CBCBCB"
                    p="24px 36px"
                    textAlign="left"
                    w="100%"
                    fontSize="1.25rem"
                    fontWeight="bold"
                    color="#2D2D2D"
                  >
                    {information.title}
                  </Heading>

                  {!isMobile ? (
                    <>
                      <HStack
                        p="1.3vw"
                        display="flex"
                        wrap="wrap"
                        bg="#fff"
                        borderRadius="1rem"
                        w="100%"
                        justifyContent={{
                          base: 'center',
                          lg: 'space-between',
                          xl: 'start'
                        }}
                        alignItems="stretch"
                        gap="0.91rem"
                      >
                        {information.cards.map((card) => {
                          return (
                            <Box
                              key={card.subtitle}
                              href={card.href}
                              display="flex"
                              flexDir="column"
                              alignItems="flex-start"
                              justifyContent="space-between"
                              w="428px"
                              border="1px solid #D0D0D0"
                              p="28px 31px"
                              borderRadius="11px"
                              margin="0 !important"
                              position="relative"
                            >
                              {card.tag && (
                                <Box
                                  bg="#001E64"
                                  w="42px"
                                  h="24px"
                                  color="#FFFFFF"
                                  fontSize="0.75rem"
                                  fontWeight="400"
                                  lineHeight="1.5rem"
                                  textAlign="center"
                                  borderRadius="7.5px"
                                  position="absolute"
                                  right="5px"
                                  top="5px"
                                >
                                  {card.tag}
                                </Box>
                              )}
                              <Heading
                                fontSize="1.25rem"
                                fontWeight="bold"
                                color="#2D2D2D"
                              >
                                {card.subtitle}
                              </Heading>
                              <Text
                                p="1.1rem 0 1.15rem"
                                fontSize="0.9rem"
                                color="#626262"
                              >
                                {card.text}
                              </Text>
                              <Link key={card.subtitle} href={card.href}>
                                <Button
                                  bg="#FA6B25"
                                  border="#FA6B25"
                                  borderRadius="32.5px"
                                  w="10vw"
                                  color="#fff"
                                  transition=".2 ease-in"
                                  _hover={{
                                    color: '#FA6B25',
                                    bg: '#fff',
                                    border: '#FA6B25'
                                  }}
                                >
                                  Acessar
                                </Button>
                              </Link>
                            </Box>
                          );
                        })}
                      </HStack>
                    </>
                  ) : (
                    <>
                      <Provider>
                        <Carousel gap={10}>
                          {information.cards.map((card) => {
                            return (
                              <Box
                                key={card.subtitle}
                                href={card.href}
                                display="flex"
                                flexDir="column"
                                alignItems="flex-start"
                                justifyContent="space-between"
                                w="400px"
                                border="1px solid #D0D0D0"
                                p="28px 31px"
                                borderRadius="11px"
                                margin="0 !important"
                              >
                                <Heading
                                  fontSize="1.25rem"
                                  fontWeight="bold"
                                  color="#2D2D2D"
                                >
                                  {card.subtitle}
                                </Heading>
                                <Text
                                  p="1.1rem 0 1.15rem"
                                  fontSize="0.9rem"
                                  color="#626262"
                                >
                                  {card.text}
                                </Text>

                                <Link
                                  key={card.subtitle}
                                  href={card.href}
                                  w="100%"
                                >
                                  <Button
                                    bg="#FA6B25"
                                    border="#FA6B25"
                                    borderRadius="32.5px"
                                    w={isMobile ? '100%' : '10vw'}
                                    color="#fff"
                                    transition=".2 ease-in"
                                    _hover={{
                                      color: '#FA6B25',
                                      bg: '#fff',
                                      border: '#FA6B25'
                                    }}
                                  >
                                    Acessar
                                  </Button>
                                </Link>
                              </Box>
                            );
                          })}
                        </Carousel>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                          w="100%"
                          px="1rem"
                          py="0.5rem"
                        >
                          <LeftButton />
                          <RightButton />
                        </Box>
                      </Provider>
                    </>
                  )}
                </VStack>
              );
            })}
          </>
        ) : (
          <>
            <HStack
              display="flex"
              wrap="wrap"
              w="100%"
              justifyContent={{
                base: 'center',
                lg: 'space-between',
                xl: 'start'
              }}
              alignItems="stretch"
              gap="0.91rem"
            >
              {informations.oportunidades.map((item) => (
                <Box
                  key={item.title}
                  display="flex"
                  flexDir="column"
                  justifyContent="space-between"
                  w="400px"
                  border="1px solid #D0D0D0"
                  p="28px 31px"
                  borderRadius="11px"
                  bg="#fff"
                  position="relative"
                >
                  {item.tag && (
                    <Box
                      bg="#126EFA"
                      w="42px"
                      h="24px"
                      color="#FFFFFF"
                      fontSize="0.75rem"
                      fontWeight="400"
                      lineHeight="1.5rem"
                      textAlign="center"
                      borderRadius="7.5px"
                      position="absolute"
                      right="5px"
                      top="5px"
                    >
                      {item.tag}
                    </Box>
                  )}
                  <Heading
                    fontSize="1.25rem"
                    fontWeight="bold"
                    color={item.tag ? '#126EFA' : '#2D2D2D'}
                    textAlign="center"
                  >
                    {item.title}
                  </Heading>
                  <Text
                    p="1.1rem 0 1.15rem"
                    fontSize="0.9rem"
                    color="#626262"
                    textAlign="center"
                  >
                    {item.text}
                  </Text>

                  <Link href={item.href}>
                    <Button
                      bg={item.tag ? '#126EFA' : '#FA6B25'}
                      border={item.tag ? '#126EFA' : '#FA6B25'}
                      borderRadius="32.5px"
                      w="100%"
                      color="#fff"
                      _hover={{
                        color: '#FA6B25',
                        bg: '#fff'
                      }}
                    >
                      {item.btnText}
                    </Button>
                  </Link>
                </Box>
              ))}
            </HStack>
          </>
        )}
      </Flex>
    </Stack>
  );
};
